/* eslint-disable jsx-a11y/anchor-is-valid */
import { CustomButton, CustomTable, GrowerDetailCard } from "#components";
import globalConfig from "#constants/globalConfig.js";
import ImagesUrl from "#constants/images.js";
import useGet from "#hooks/useGet.js";
import { AdminLayout, TableLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { GenerateFile } from "#utils/downloadFile.js";
import { convertDate } from "#utils/helpers.js";
import React, { useState } from "react";

const ScoutingDetail = () => {
  const [expandedScoutingRow, setExpandedScoutingRow] = useState(null);
  const GrowerId = JSON.parse(
    localStorage.getItem(globalConfig.ADMIN_GROWER_ID)
  );
  const ScoutingId = JSON.parse(localStorage.getItem(globalConfig.SCOUTING_ID));

  const { data: scoutingDetail, isLoading: scoutingDetailLoading } = useGet(
    ENDPOINTS.SCOUTING_DETAIL,
    QUERY_KEYS.SCOUTING_DETAIL_QUERY_KEY,
    {
      scoutingId: ScoutingId,
    }
  );

  const scoutingDetailData = scoutingDetail?.data[0];
  const toggleScoutingRow = (index) => {
    setExpandedScoutingRow(expandedScoutingRow === index ? null : index);
  };

  const handleDownload = () => {
    GenerateFile(scoutingDetailData?.pdf, "Scouting-Report.pdf");
  };

  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          <GrowerDetailCard GrowerId={GrowerId} />
          <div class="row mt-4">
            <div class="col-12">
              <div class="sub-heading mb-2">
                {/* <h2 class="text-start fs-4">Subject</h2> */}
              </div>
            </div>
            <div class="col-lg-7">
              <TableLayout
                tableHeader={[
                  {
                    name: "Field",
                  },
                  {
                    name: "Crop",
                  },
                  {
                    name: "Acres",
                  },
                ]}
                isEmpty={scoutingDetail?.data.length === 0}
                isLoading={scoutingDetailLoading}
                pagination="true"
              >
                <CustomTable
                  tableHeader={[
                    {
                      name: "Field",
                    },
                    {
                      name: "Crop",
                    },
                    {
                      name: "Acres",
                    },
                  ]}
                >
                  {scoutingDetail?.data?.map((item, index) => {
                    return item?.fieldsDetail.map((data, i) => (
                      <React.Fragment key={data?._id || `${index}-${i}`}>
                        <tr className="cursor-pointer position-relative">
                          <td
                            onClick={() => toggleScoutingRow(`${index}-${i}`)}
                          >
                            <span className="hstack gap-3">
                              {data?.subfield?.length > 0 ? (
                                <span
                                  className={`drop_icon ${
                                    expandedScoutingRow === `${index}-${i}`
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <img
                                    onClick={() =>
                                      toggleScoutingRow(`${index}-${i}`)
                                    }
                                    className="drop_icon"
                                    src={ImagesUrl.dopeIcon}
                                    alt="drop-icon"
                                  />
                                </span>
                              ) : (
                                <span className="drop_icon"></span>
                              )}
                              <span>{data?.name || "-"}</span>
                            </span>
                          </td>
                          <td
                            onClick={() => toggleScoutingRow(`${index}-${i}`)}
                          >
                            {data?.cropData[0]?.cropName || "-"}
                          </td>
                          <td
                            onClick={() => toggleScoutingRow(`${index}-${i}`)}
                          >
                            {data?.area || "-"}
                          </td>
                        </tr>
                        {expandedScoutingRow === `${index}-${i}` &&
                          data?.subfield?.map((subRowData, subIndex) => (
                            <tr
                              className="cursor-pointer"
                              key={subRowData?._id || subIndex}
                            >
                              <td>{subRowData?.name || "-"}</td>
                              <td>{subRowData?.area || "-"}</td>
                            </tr>
                          ))}
                      </React.Fragment>
                    ));
                  })}
                </CustomTable>
              </TableLayout>
            </div>
            <div class="col-lg-5">
              <div class="countdown_blk">
                <h3 class="fs-6 text-center mb-0">Scout Time</h3>
                <h4 class="fs-4 fw-bold mb-0 text-center">
                  {scoutingDetailData?.scoutTimeTaken}
                </h4>
                <div class="hstack justify-content-center gap-4">
                  <span>
                    Date: {convertDate(scoutingDetailData?.createdAt)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="wrapper-card mt-4">
            <div className="row">
              <div className="col-xl-6">
                <h2 className="fs-6 fw-medium mb-0">Crop Stage</h2>
                <div className="content_blk">
                  <p>{scoutingDetailData?.cropStageText}</p>
                  <div className="d-flex justify-content-start gap-3">
                    {scoutingDetailData?.cropStageAttachments?.map(
                      (item, i) => {
                        const isPdf = item.endsWith(".pdf");
                        return (
                          <div className="common-sub-heading" key={i}>
                            <div
                              className="msds-preview-file"
                              onClick={() => window.open(item, "_blank")}
                            >
                              {isPdf ? (
                                <span className="file_icon">
                                  <img src={ImagesUrl.pdfIcon} alt="file" />
                                </span>
                              ) : (
                                <img
                                  src={item}
                                  alt="Download PDF"
                                  height="100%"
                                  width="100%"
                                />
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Observation Attachments */}
          <div className="wrapper-card mt-4">
            <div className="row">
              <div className="col-xl-12">
                <h2 className="fs-6 fw-medium mb-0">Observations</h2>
                {scoutingDetailData?.observationAttachments?.length > 0 ? (
                  scoutingDetailData.observationAttachments.map(
                    (obs, index) => (
                      <div className="content_blk mt-3" key={`obs-${index}`}>
                        <p className="fw-medium mb-2">
                          Observation {index + 1}: {obs?.text}
                        </p>
                        <div className="d-flex justify-content-start gap-3 flex-wrap mt-2">
                          {obs?.attachments?.map((item, i) => {
                            const isPdf = item.endsWith(".pdf");
                            return (
                              <div
                                className="common-sub-heading"
                                key={`obs-attach-${index}-${i}`}
                              >
                                {isPdf ? (
                                  <div
                                    className="msds-preview-file"
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span className="file_icon">
                                      <img
                                        src={ImagesUrl.pdfIcon}
                                        alt="PDF File"
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="msds-preview-file"
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <img
                                      src={item}
                                      alt="Observation Attachment"
                                      height="100%"
                                      width="100%"
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <p className="mt-3 text-muted">No observations available.</p>
                )}
              </div>
            </div>
          </div>

          {/* <div class="wrapper-card">
            <div class="row">
              <div class="col-xl-12">
                <h2 className="fs-6 fw-medium mb-0">Recommendation</h2>
                <div className="content_blk">
                  <p>{scoutingDetailData?.recommendationNote}</p>

                  <div className="d-flex justify-content-start gap-3 mt-3">
                    {scoutingDetailData?.recommendationAttachments?.map(
                      (item, i) => {
                        const isPdf = item.endsWith(".pdf");
                        return (
                          <div className="common-sub-heading" key={i}>
                            {isPdf ? (
                              <div
                                className="msds-preview-file"
                                onClick={() => window.open(item, "_blank")}
                              >
                                <span className="file_icon">
                                  <img src={ImagesUrl.pdfIcon} alt="file" />
                                </span>
                              </div>
                            ) : (
                              <div
                                className="msds-preview-file"
                                onClick={() => window.open(item, "_blank")}
                              >
                                <img src={item} alt="Download PDF" />
                              </div>
                            )}
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* Recommendation Attachments */}
          <div className="wrapper-card mt-4">
            <div className="row">
              <div className="col-xl-12">
                <h2 className="fs-6 fw-medium mb-0">Recommendations</h2>
                {scoutingDetailData?.recommendationAttachments?.length > 0 ? (
                  scoutingDetailData.recommendationAttachments.map(
                    (rec, index) => (
                      <div className="content_blk mt-3" key={`rec-${index}`}>
                        <p className="fw-medium mb-2">
                          Recommendation {index + 1}: {rec?.text}
                        </p>
                        <div className="d-flex justify-content-start gap-3 flex-wrap mt-2">
                          {rec?.attachments?.map((item, i) => {
                            const isPdf = item.endsWith(".pdf");
                            return (
                              <div
                                className="common-sub-heading"
                                key={`rec-attach-${index}-${i}`}
                              >
                                {isPdf ? (
                                  <div
                                    className="msds-preview-file"
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span className="file_icon">
                                      <img
                                        src={ImagesUrl.pdfIcon}
                                        alt="PDF File"
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  <div
                                    className="msds-preview-file"
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <img
                                      src={item}
                                      alt="Recommendation Attachment"
                                      height="100%"
                                      width="100%"
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <p className="mt-3 text-muted">
                    No recommendations available.
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* <div class="wrapper-card col-xl-4">
            <div class="row">
              <div class="col-xl-6">
                <h2 className="fs-6 fw-medium mb-0">Mix Sheet</h2>
                <div class="file_item_title py-2 px-0 border-0">
                  {scoutingDetailData?.sheetAttachments?.map((item, i) => {
                    const isPdf = item.endsWith(".pdf");
                    return (
                      <div className="common-sub-heading" key={i}>
                        {isPdf ? (
                          <div
                            className="msds-preview-file"
                            onClick={() => window.open(item, "_blank")}
                          >
                            <span className="file_icon">
                              <img src={ImagesUrl.pdfIcon} alt="file" />
                            </span>
                          </div>
                        ) : (
                          <div className="msds-preview-file">
                            <img src={item} alt="Download PDF" />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}
          <CustomButton
            title="Generate Report"
            className="report-btn"
            onClick={handleDownload}
          />
        </div>
      </section>
    </AdminLayout>
  );
};

export default ScoutingDetail;
/* eslint-disable jsx-a11y/anchor-is-valid */
// import { CustomTable, GrowerDetailCard } from "#components";
// import globalConfig from "#constants/globalConfig.js";
// import ImagesUrl from "#constants/images.js";
// import useGet from "#hooks/useGet.js";
// import { TableLayout, WebLayout } from "#layouts";
// import ENDPOINTS from "#services/endPoints.js";
// import QUERY_KEYS from "#services/queryKeys.js";
// import { convertDate } from "#utils/helpers.js";
// import React, { useState } from "react";

// const ScoutingDetail = () => {
//   const [expandedScoutingRow, setExpandedScoutingRow] = useState(null);
//   const GrowerId = JSON.parse(localStorage.getItem(globalConfig.GROWER_ID));
//   const ScoutingId = JSON.parse(localStorage.getItem(globalConfig.SCOUTING_ID));

//   const { data: scoutingDetail, isLoading: scoutingDetailLoading } = useGet(
//     ENDPOINTS.SCOUTING_DETAIL,
//     QUERY_KEYS.SCOUTING_DETAIL_QUERY_KEY,
//     { scoutingId: ScoutingId }
//   );

//   const scoutingDetailData = scoutingDetail?.data[0];
//   const toggleScoutingRow = (index) => {
//     setExpandedScoutingRow(expandedScoutingRow === index ? null : index);
//   };

//   return (
//     <WebLayout>
//       <section className="main-section spacer">
//         <div className="container">
//           <GrowerDetailCard GrowerId={GrowerId} />

//           {/* Field and Scout Time */}
//           <div className="row mt-4">
//             <div className="col-12">
//               <div className="sub-heading mb-2">
//                 <h2 className="text-start fs-4">Subject</h2>
//               </div>
//             </div>
//             <div className="col-lg-7">
//               <TableLayout
//                 tableHeader={[{ name: "Field" }, { name: "Acres" }]}
//                 isEmpty={scoutingDetail?.data.length === 0}
//                 isLoading={scoutingDetailLoading}
//                 pagination="true"
//               >
//                 <CustomTable
//                   tableHeader={[{ name: "Field" }, { name: "Acres" }]}
//                 >
//                   {scoutingDetail?.data?.map((item, index) =>
//                     item?.fieldsDetail.map((data, i) => (
//                       <React.Fragment key={data?._id || `${index}-${i}`}>
//                         <tr className="cursor-pointer position-relative">
//                           <td
//                             onClick={() => toggleScoutingRow(`${index}-${i}`)}
//                           >
//                             <span className="hstack gap-3">
//                               {data?.subfield?.length > 0 ? (
//                                 <span
//                                   className={`drop_icon ${
//                                     expandedScoutingRow === `${index}-${i}`
//                                       ? "active"
//                                       : ""
//                                   }`}
//                                 >
//                                   <img
//                                     onClick={() =>
//                                       toggleScoutingRow(`${index}-${i}`)
//                                     }
//                                     className="drop_icon"
//                                     src={ImagesUrl.dopeIcon}
//                                     alt="drop-icon"
//                                   />
//                                 </span>
//                               ) : (
//                                 <span className="drop_icon" />
//                               )}
//                               <span>{data?.name || "-"}</span>
//                             </span>
//                           </td>
//                           <td
//                             onClick={() => toggleScoutingRow(`${index}-${i}`)}
//                           >
//                             {data?.area || "-"}
//                           </td>
//                         </tr>
//                         {expandedScoutingRow === `${index}-${i}` &&
//                           data?.subfield?.map((subRowData, subIndex) => (
//                             <tr
//                               className="cursor-pointer"
//                               key={subRowData?._id || subIndex}
//                             >
//                               <td>{subRowData?.name || "-"}</td>
//                               <td>{subRowData?.area || "-"}</td>
//                             </tr>
//                           ))}
//                       </React.Fragment>
//                     ))
//                   )}
//                 </CustomTable>
//               </TableLayout>
//             </div>
//             <div className="col-lg-5">
//               <div className="countdown_blk">
//                 <h3 className="fs-6 text-center mb-0">Scout Time</h3>
//                 <h4 className="fs-4 fw-bold mb-0 text-center">
//                   {scoutingDetailData?.scoutTimeTaken}
//                 </h4>
//                 <div className="hstack justify-content-center gap-4">
//                   <span>
//                     Date: {convertDate(scoutingDetailData?.createdAt)}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Crop Stage */}
//           <div className="wrapper-card mt-4">
//             <div className="row">
//               <div className="col-xl-6">
//                 <h2 className="fs-6 fw-medium mb-0">Crop Stage</h2>
//                 <div className="content_blk">
//                   <p>{scoutingDetailData?.cropStageText}</p>
//                   <div className="d-flex justify-content-start gap-3">
//                     {scoutingDetailData?.cropStageAttachments?.map(
//                       (item, i) => {
//                         const isPdf = item.endsWith(".pdf");
//                         return (
//                           <div className="common-sub-heading" key={i}>
//                             {isPdf ? (
//                               <div
//                                 className="msds-preview-file"
//                                 onClick={() => window.open(item, "_blank")}
//                               >
//                                 <span className="file_icon">
//                                   <img src={ImagesUrl.pdfIcon} alt="file" />
//                                 </span>
//                               </div>
//                             ) : (
//                               <div
//                                 className="msds-preview-file"
//                                 onClick={() => window.open(item, "_blank")}
//                               >
//                                 <img
//                                   src={item}
//                                   alt="Crop Stage Attachment"
//                                   height="100%"
//                                   width="100%"
//                                 />
//                               </div>
//                             )}
//                           </div>
//                         );
//                       }
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Observation Attachments */}
//           <div className="wrapper-card mt-4">
//             <div className="row">
//               {scoutingDetailData?.observationAttachments?.map((obs, index) => (
//                 <div className="col-xl-12" key={`obs-${index}`}>
//                   <h2 className="fs-6 fw-medium mb-0">
//                     Observation {index + 1}
//                   </h2>
//                   <div className="content_blk">
//                     <p className="fw-medium mb-2">{obs?.text}</p>
//                     <div className="d-flex justify-content-start gap-3 flex-wrap mt-2">
//                       {obs?.attachments?.map((item, i) => {
//                         const isPdf = item.endsWith(".pdf");
//                         return (
//                           <div
//                             className="common-sub-heading"
//                             key={`obs-attach-${index}-${i}`}
//                           >
//                             {isPdf ? (
//                               <div
//                                 className="msds-preview-file"
//                                 onClick={() => window.open(item, "_blank")}
//                               >
//                                 <span className="file_icon">
//                                   <img src={ImagesUrl.pdfIcon} alt="PDF File" />
//                                 </span>
//                               </div>
//                             ) : (
//                               <div
//                                 className="msds-preview-file"
//                                 onClick={() => window.open(item, "_blank")}
//                               >
//                                 <img
//                                   src={item}
//                                   alt="Observation Attachment"
//                                   height="100%"
//                                   width="100%"
//                                 />
//                               </div>
//                             )}
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Recommendations */}
//           <div className="wrapper-card mt-4">
//             <div className="row">
//               {scoutingDetailData?.recommendationAttachments?.map(
//                 (rec, index) => (
//                   <div className="col-xl-12" key={`rec-section-${index}`}>
//                     <h2 className="fs-6 fw-medium mb-0">
//                       Recommendation {index + 1}
//                     </h2>
//                     <div className="content_blk">
//                       <p className="fw-medium mb-2">{rec?.text}</p>
//                       <div className="d-flex justify-content-start gap-3 flex-wrap mt-2">
//                         {rec?.attachments?.map((item, i) => {
//                           const isPdf = item.endsWith(".pdf");
//                           return (
//                             <div
//                               className="common-sub-heading"
//                               key={`rec-attach-${index}-${i}`}
//                             >
//                               {isPdf ? (
//                                 <div
//                                   className="msds-preview-file"
//                                   onClick={() => window.open(item, "_blank")}
//                                 >
//                                   <span className="file_icon">
//                                     <img
//                                       src={ImagesUrl.pdfIcon}
//                                       alt="PDF File"
//                                     />
//                                   </span>
//                                 </div>
//                               ) : (
//                                 <div
//                                   className="msds-preview-file"
//                                   onClick={() => window.open(item, "_blank")}
//                                 >
//                                   <img
//                                     src={item}
//                                     alt="Recommendation Attachment"
//                                     height="100%"
//                                     width="100%"
//                                   />
//                                 </div>
//                               )}
//                             </div>
//                           );
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                 )
//               )}
//             </div>
//           </div>

//           {/* Mix Sheet */}
//           <div className="wrapper-card col-xl-4">
//             <div className="row">
//               <div className="col-xl-6">
//                 <h2 className="fs-6 fw-medium mb-0">Mix Sheet</h2>
//                 <div className="file_item_title py-2 px-0 border-0">
//                   {scoutingDetailData?.sheetAttachments?.map((item, i) => {
//                     const isPdf = item.endsWith(".pdf");
//                     return (
//                       <div className="common-sub-heading" key={i}>
//                         {isPdf ? (
//                           <div
//                             className="msds-preview-file"
//                             onClick={() => window.open(item, "_blank")}
//                           >
//                             <span className="file_icon">
//                               <img src={ImagesUrl.pdfIcon} alt="file" />
//                             </span>
//                           </div>
//                         ) : (
//                           <div className="msds-preview-file">
//                             <img src={item} alt="Mix Sheet" />
//                           </div>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </WebLayout>
//   );
// };

// export default ScoutingDetail;
